var map = {
	"./ion-action-sheet-ios.entry.js": [
		235,
		112
	],
	"./ion-action-sheet-md.entry.js": [
		236,
		113
	],
	"./ion-alert-ios.entry.js": [
		237,
		93
	],
	"./ion-alert-md.entry.js": [
		238,
		94
	],
	"./ion-app_8-ios.entry.js": [
		239,
		76
	],
	"./ion-app_8-md.entry.js": [
		240,
		77
	],
	"./ion-avatar_3-ios.entry.js": [
		241,
		114
	],
	"./ion-avatar_3-md.entry.js": [
		242,
		115
	],
	"./ion-back-button-ios.entry.js": [
		243,
		116
	],
	"./ion-back-button-md.entry.js": [
		244,
		117
	],
	"./ion-backdrop-ios.entry.js": [
		245,
		157
	],
	"./ion-backdrop-md.entry.js": [
		246,
		158
	],
	"./ion-button_2-ios.entry.js": [
		247,
		118
	],
	"./ion-button_2-md.entry.js": [
		248,
		119
	],
	"./ion-card_5-ios.entry.js": [
		249,
		120
	],
	"./ion-card_5-md.entry.js": [
		250,
		121
	],
	"./ion-checkbox-ios.entry.js": [
		251,
		122
	],
	"./ion-checkbox-md.entry.js": [
		252,
		123
	],
	"./ion-chip-ios.entry.js": [
		253,
		124
	],
	"./ion-chip-md.entry.js": [
		254,
		125
	],
	"./ion-col_3.entry.js": [
		255,
		159
	],
	"./ion-datetime_3-ios.entry.js": [
		256,
		89
	],
	"./ion-datetime_3-md.entry.js": [
		257,
		90
	],
	"./ion-fab_3-ios.entry.js": [
		258,
		126
	],
	"./ion-fab_3-md.entry.js": [
		259,
		127
	],
	"./ion-img.entry.js": [
		260,
		160
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		261,
		110
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		262,
		111
	],
	"./ion-input-ios.entry.js": [
		263,
		128
	],
	"./ion-input-md.entry.js": [
		264,
		129
	],
	"./ion-item-option_3-ios.entry.js": [
		265,
		130
	],
	"./ion-item-option_3-md.entry.js": [
		266,
		131
	],
	"./ion-item_8-ios.entry.js": [
		267,
		132
	],
	"./ion-item_8-md.entry.js": [
		268,
		133
	],
	"./ion-loading-ios.entry.js": [
		269,
		95
	],
	"./ion-loading-md.entry.js": [
		270,
		96
	],
	"./ion-menu_3-ios.entry.js": [
		271,
		134
	],
	"./ion-menu_3-md.entry.js": [
		272,
		135
	],
	"./ion-modal-ios.entry.js": [
		273,
		78
	],
	"./ion-modal-md.entry.js": [
		274,
		79
	],
	"./ion-nav_2.entry.js": [
		275,
		88
	],
	"./ion-popover-ios.entry.js": [
		276,
		80
	],
	"./ion-popover-md.entry.js": [
		277,
		81
	],
	"./ion-progress-bar-ios.entry.js": [
		278,
		136
	],
	"./ion-progress-bar-md.entry.js": [
		279,
		137
	],
	"./ion-radio_2-ios.entry.js": [
		280,
		138
	],
	"./ion-radio_2-md.entry.js": [
		281,
		139
	],
	"./ion-range-ios.entry.js": [
		282,
		140
	],
	"./ion-range-md.entry.js": [
		283,
		141
	],
	"./ion-refresher_2-ios.entry.js": [
		284,
		97
	],
	"./ion-refresher_2-md.entry.js": [
		285,
		98
	],
	"./ion-reorder_2-ios.entry.js": [
		286,
		108
	],
	"./ion-reorder_2-md.entry.js": [
		287,
		109
	],
	"./ion-ripple-effect.entry.js": [
		288,
		161
	],
	"./ion-route_4.entry.js": [
		289,
		142
	],
	"./ion-searchbar-ios.entry.js": [
		290,
		143
	],
	"./ion-searchbar-md.entry.js": [
		291,
		144
	],
	"./ion-segment_2-ios.entry.js": [
		292,
		145
	],
	"./ion-segment_2-md.entry.js": [
		293,
		146
	],
	"./ion-select_3-ios.entry.js": [
		294,
		147
	],
	"./ion-select_3-md.entry.js": [
		295,
		148
	],
	"./ion-slide_2-ios.entry.js": [
		296,
		162
	],
	"./ion-slide_2-md.entry.js": [
		297,
		163
	],
	"./ion-spinner.entry.js": [
		298,
		101
	],
	"./ion-split-pane-ios.entry.js": [
		299,
		164
	],
	"./ion-split-pane-md.entry.js": [
		300,
		165
	],
	"./ion-tab-bar_2-ios.entry.js": [
		301,
		149
	],
	"./ion-tab-bar_2-md.entry.js": [
		302,
		150
	],
	"./ion-tab_2.entry.js": [
		303,
		107
	],
	"./ion-text.entry.js": [
		304,
		151
	],
	"./ion-textarea-ios.entry.js": [
		305,
		152
	],
	"./ion-textarea-md.entry.js": [
		306,
		153
	],
	"./ion-toast-ios.entry.js": [
		307,
		99
	],
	"./ion-toast-md.entry.js": [
		308,
		100
	],
	"./ion-toggle-ios.entry.js": [
		309,
		91
	],
	"./ion-toggle-md.entry.js": [
		310,
		92
	],
	"./ion-virtual-scroll.entry.js": [
		311,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 183;
module.exports = webpackAsyncContext;